import React from 'react';
import './pricing.css';
import Image1 from "../../assets/price-1.png";
import Image2 from "../../assets/price-2.png";
import Image3 from "../../assets/price-3.png";


const Pricing = () => {
    return (
        <section className="pricing container section" id='pricing'>
            <h2 className="section__title">Paw Plans</h2>

            <div className="pricing__container grid">
                <div className="pricing__item">
                    <img src={Image1} alt="" className="pricing__img" />
                    <h3 className="pricing__plan">Dog Walking</h3>
                    <p className="pricing__title">Your fur baby  will have plenty of stimulation, fun, games & fetch at the beach/ park.</p>
                    <p className="pricing__support">Collect your dog from your house and walk and/or transport them to a suitable beach, park or bay.</p>
                    <h3 className="price">
                        <em>$</em> 70 <span> /Time </span>
                    </h3>
                    <a href="#contact" className="btn">Get Started</a>
                </div>
                <div className="pricing__item">
                    <img src={Image2} alt="" className="pricing__img" />
                    <h3 className="pricing__plan">Dog Sitting</h3>
                    <p className="pricing__title">Your fur baby  will have plenty of stimulation, fun, games & fetch at the beach/ park.</p>
                    <p className="pricing__support">Collect your dog from your house and walk and/or transport them to a suitable beach, park or bay.</p>
                    <h3 className="price">
                        <em>$</em> 100 <span> /Day </span>
                    </h3>
                    <a href="#contact" className="btn">Get Started</a>
                </div>
                <div className="pricing__item">
                    <img src={Image3} alt="" className="pricing__img" />
                    <h3 className="pricing__plan">Dog Visiting</h3>
                    <p className="pricing__title">Your fur baby  will have plenty of stimulation, fun, games & fetch at the beach/ park.</p>
                    <p className="pricing__support">Collect your dog from your house and walk and/or transport them to a suitable beach, park or bay.</p>
                    <h3 className="price">
                        <em>$</em> 80 <span> /Day </span>
                    </h3>
                    <a href="#contact" className="btn">Get Started</a>
                </div>
            </div>

        </section>
    );
};

export default Pricing;